import MODAL_MODE from '../../../../../pages/data/common/constants';
import { ExtensionTimelineEntry } from '../../../../../common/types/timeline/ExtensionPeriodEntryType';

const actions = {
  OPEN_EXTENSION_MODAL: 'OPEN_EXTENSION_MODAL',
  CLOSE_EXTENSION_MODAL: 'CLOSE_EXTENSION_MODAL',
  SET_CURRENT_EXTENSION_PERIOD: 'SET_CURRENT_EXTENSION_PERIOD',
};

export interface actionInterface {
  type: string;
  payload: any;
}

interface openExtensionModalInterface {
  type: typeof actions.OPEN_EXTENSION_MODAL;
  payload: {
    modalMode: MODAL_MODE;
    modalOpen: boolean;
  };
}

interface closeExtensionModalInterface {
  type: typeof actions.CLOSE_EXTENSION_MODAL;
  payload: {
    modalOpen: boolean;
  };
}

interface setCurrentExtensionPeriod {
  type: typeof actions.SET_CURRENT_EXTENSION_PERIOD;
  payload: {
    currentExtensionPeriod: ExtensionTimelineEntry;
  };
}

const openModal = (modalMode: MODAL_MODE): openExtensionModalInterface => {
  return {
    type: actions.OPEN_EXTENSION_MODAL,
    payload: { modalOpen: true, modalMode },
  };
};

const closeModal = (): closeExtensionModalInterface => {
  return {
    type: actions.CLOSE_EXTENSION_MODAL,
    payload: { modalOpen: false },
  };
};

const setCurrentExtensionPeriod = (currentExtensionPeriod: ExtensionTimelineEntry): setCurrentExtensionPeriod => {
  return {
    type: actions.SET_CURRENT_EXTENSION_PERIOD,
    payload: { currentExtensionPeriod },
  };
}

export {
  closeModal,
  openModal,
  setCurrentExtensionPeriod
}

export default actions;
